export default "__VITE_ASSET__CLPZTou1__"